import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { GeneratedContentPage } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import { buildQueryKey } from 'utils/buildQueryKey';
import clientUtil from 'utils/clientUtil';

type TVariables = object;
type TData = number;

const MOCK: TVariables = {};

export const useContentGenerationNodesCount = (
  variables: TVariables = MOCK,
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query generatedContents {
      generatedContents {
        nodesCount
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['useContentGenerationNodesCount', ...buildQueryKey({ ...MOCK, ...variables })],
    queryFn: async () => {
      return (
        (await client.request({
          data: {
            gql: graphql,
            variables
          }
        })) as GeneratedContentPage
      )?.nodesCount;
    }
  });
};
